import { inject, Injectable } from '@angular/core';
import { FuncService } from '../../services';


@Injectable({ providedIn: 'root' })
export class DevoAreaService {

	private func = inject(FuncService);




}